// src/api/school.js
import request from '@/utils/request'

// api接口列表
const api = {
	scenery: 'university/scenery',
	list: 'university/list',
	detail: 'university/detail',
	circle: 'university/search/region',
	type: 'university/institution/level',

	university: 'university/institution/profile',
	majors: 'university/search_majors',

	recommend: 'university/recommend',
	rank: 'university/rank',
	ranking: 'university/ranking',

	departmentalSetup: 'university/college/majors',
	branch: 'university/branch/school',
	branchD: 'university/branch/info',

	majorsT: 'university/majors/type', // 院校详情--开设专业--专业类别筛选条件
	majorsL: '/university/majors', // 院校详情--开设专业
	majorsD: 'university/majors/detail',

	yearT: 'university/select/type', // 院校详情历年分数招生计划筛选条件---类型
	yearB: 'university/select/batch', // 院校详情历年分数招生计划筛选条件---批次
	yearY: 'university/select/year', // 院校详情历年分数筛选条件---年份
	yearP: 'university/select/plan_year', // 院校详情招生计划筛选条件---年份


	lineGroup: 'university/detail/major_group', // 院校详情历年分数---专业组
	lineSchool: 'university/detail/score', // 院校详情历年分数（院校分数线）
	lineMajor: 'university/detail/major_score', // 院校详情历年分数（专业分数线）
	plan: 'university/detail/plan', // 招生计划
	compare: 'university/compare' // 对比

}


// 风光
export function scenery(params) {
	// params 是 GET 请求的参数（如分页、筛选）
	// data 是 POST 请求的请求体
	return request({
		url: api.scenery,
		method: 'get',
		params
	})
}
// 列表
export function list(params) {
	return request({
		url: api.list,
		method: 'get',
		params
	})
}

// 详情
export function detail(params) {
	return request({
		url: api.detail,
		method: 'get',
		params
	})
}

// 经济圈
export function circle(params) {
	return request({
		url: api.circle,
		method: 'get',
		params
	})
}

// 院校列表筛选条件--院校类型
export function type(params) {
	return request({
		url: api.type,
		method: 'get',
		params
	})
}

// 院校列表筛选条件--院校 --院校类型、教育水平、院校性质
export function university(params) {
	return request({
		url: api.university,
		method: 'get',
		params
	})
}

// 院校列表筛选条件--专业
export function majors(params) {
	return request({
		url: api.majors,
		method: 'get',
		params
	})
}

// 推荐院校
export function recommend(params) {
	return request({
		url: api.recommend,
		method: 'get',
		params
	})
}

// 院校排名
export function rank(params) {
	return request({
		url: api.rank,
		method: 'get',
		params
	})
}


// 院校排行榜
export function ranking(params) {
	return request({
		url: api.ranking,
		method: 'get',
		params
	})
}

// 院校详情--院系设置
export function departmentalSetup(params) {
	return request({
		url: api.departmentalSetup,
		method: 'get',
		params
	})
}


// 院校详情--院校分校列表
export function branch(params) {
	return request({
		url: api.branch,
		method: 'get',
		params
	})
}

// 院校详情--院校分校信息
export function branchD(params) {
	return request({
		url: api.branchD,
		method: 'get',
		params
	})
}

export function majorsT(params) {
	return request({
		url: api.majorsT,
		method: 'get',
		params
	})
}

export function yearT(params) {
	return request({
		url: api.yearT,
		method: 'get',
		params
	})
}


export function majorsL(params) {
	return request({
		url: api.majorsL,
		method: 'get',
		params
	})
}


// 开设专业详情
export function majorsD(params) {
	return request({
		url: api.majorsD,
		method: 'get',
		params
	})
}

export function yearB(params) {
	return request({
		url: api.yearB,
		method: 'get',
		params
	})
}
export function yearY(params) {
	return request({
		url: api.yearY,
		method: 'get',
		params
	})
}
export function yearP(params) {
	return request({
		url: api.yearP,
		method: 'get',
		params
	})
}
export function lineGroup(data) {
	return request({
		url: api.lineGroup,
		method: 'post',
		data
	})
}

export function lineSchool(data) {
	return request({
		url: api.lineSchool,
		method: 'post',
		data
	})
}

export function lineMajor(data) {
	return request({
		url: api.lineMajor,
		method: 'post',
		data
	})
}

export function plan(data) {
	return request({
		url: api.plan,
		method: 'post',
		data
	})
}

export function compare(params) {
	return request({
		url: api.compare,
		method: 'get',
		params
	})
}